import { useEffect, useState } from "react";

const links = [
  { label: "题材概览", href: "#overview" },
  { label: "场景对比", href: "#compare" },
  { label: "角色原型", href: "#roles" },
  { label: "情境筛选", href: "#scenarios" },
  { label: "互动解析", href: "#details" },
  { label: "章节脉络", href: "#chapters" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 group">
          <span
            className={`w-9 h-9 rounded-md flex items-center justify-center ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/15 text-background-50"
            }`}
          >
            <i className="ri-book-marked-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-base font-bold tracking-wide ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              秘密教学
            </span>
            <span
              className={`font-label text-[10px] tracking-[0.24em] ${
                solid ? "text-foreground-500" : "text-background-50/70"
              }`}
            >
              师生家教题材全解析
            </span>
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-1">
          {links.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className={`px-3 py-2 rounded-md font-label text-sm transition-colors whitespace-nowrap ${
                  solid
                    ? "text-foreground-700 hover:text-primary-700 hover:bg-primary-100/60"
                    : "text-background-50/85 hover:text-background-50 hover:bg-background-50/10"
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#chapters"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 font-label text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            <i className="ri-list-check-2" />
            查看章节
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md border ${
              solid
                ? "border-background-300 text-foreground-900"
                : "border-background-50/30 text-background-50"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <ul className="grid grid-cols-2 gap-1.5">
            {links.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="block px-3 py-2.5 rounded-md font-label text-sm text-foreground-700 hover:bg-primary-100/60 hover:text-primary-700"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}